import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';

// Extra
import SwipeableViews from 'react-swipeable-views-react-18-fix';
import { autoPlay } from 'react-swipeable-views-utils-react-18-fix';
import { useTheme } from '@emotion/react';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);



function Campaigns(props) {

    // Props
    const { t } = useTranslation()
    const campaigns = useSelector(state => state.campaigns)

    const theme = useTheme()
    // Styles
    const style = {
        image: {
            objectFit: 'fill',
            width: '100%',
            marginBottom: '-5px',
        },
        mobileStepperRoot: {
            flexGrow: 1,
            position: 'absolute',
            left: 0,
            top: 0,
            backgroundColor: theme.palette.common.transparent
        },
    }
    // Campaigns
    const [campaignIndex, setCampaignIndex] = useState(0);

    return (
        <Box width={1} boxShadow={2} bgcolor="background.paper" position='relative'>
            <AutoPlaySwipeableViews
                index={campaignIndex}
                onChangeIndex={(index) => setCampaignIndex(index)}
                enableMouseEvents
                interval={5000}
            >
                {
                    campaigns.map(campaign => (
                        <img key={campaign.id} src={campaign.imageUrl} alt='' style={style.image}></img>
                    ))
                }
            </AutoPlaySwipeableViews>
            <MobileStepper
                variant="dots"
                steps={campaigns.length}
                position="static"
                activeStep={campaignIndex}
                sx={style.mobileStepperRoot}
            />
        </Box>
    )
}

// Connect redux and translation
export default Campaigns
